import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const AgencyIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 -1 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.05577 7.43598H23V4.50752H6.06768L5.05577 7.43598ZM5.00883 4.50752L3.99692 7.43598H1V4.50752H5.00883ZM5.70066 3.50014H0.841C0.375976 3.50014 0 3.87966 0 4.34734V7.59615C0 8.06473 0.375858 8.44336 0.841 8.44336H1.6322V19.1904C1.6322 19.9136 2.21481 20.5 2.9322 20.5H7.5654H16.4344H21.0672C21.7846 20.5 22.3672 19.9136 22.3672 19.1904V8.44336H23.159C23.6233 8.44336 24 8.06461 24 7.59615V4.34734C24 3.87978 23.6231 3.50014 23.159 3.50014H5.72391C5.71614 3.49995 5.70839 3.49995 5.70066 3.50014ZM16.9344 19.4926H21.0672C21.2325 19.4926 21.3672 19.357 21.3672 19.1904V8.44366H2.6322V19.1904C2.6322 19.357 2.7669 19.4926 2.9322 19.4926H7.0654V11.5303C7.0654 11.1402 7.3793 10.8251 7.7654 10.8251H11.9772C11.9847 10.8248 11.9922 10.8246 11.9998 10.8246C12.0074 10.8246 12.0149 10.8248 12.0224 10.8251H16.2344C16.6205 10.8251 16.9344 11.1402 16.9344 11.5303V19.4926ZM8.0654 11.8325H11.4998V19.4926H8.0654V11.8325ZM15.9344 19.4926H12.4998V11.8325H15.9344V19.4926Z'
        fill='currentColor'
      />
    </svg>
  );
};
